// extracted by mini-css-extract-plugin
export default {"flavor_option":"z0","out_of_stock_text":"A0","out_of_stock":"B0","flavor_option_image":"C0","flavor_option_info":"E0","flavor_option_title":"F0","flavor_option_limited":"G0","flavor_option_amount_wrapper":"H0","flavor_option_amount_button":"I0","zero_amount":"J0","no_flavors":"K0","no_flavors_active":"L0","flavor_option_select_wrapper":"M0","flavor_option_select_wrapper__selected":"N0"};
    if(module.hot) {
      // 1730991512061
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  